/** Object key layout on the bucket. Mirrors `SyncPaths` in SyncModels.swift. */

export const ROOT_PREFIX = 'jnote/v1/';

export const VAULT_META_KEY = `${ROOT_PREFIX}vault/meta.json`;
export const VAULT_DEK_KEY = `${ROOT_PREFIX}vault/dek.wrapped`;

export function folderKey(id: string): string {
  return `${ROOT_PREFIX}folders/${id}.json`;
}

export function noteKey(id: string): string {
  return `${ROOT_PREFIX}notes/${id}.json`;
}

export function attachmentKey(id: string, filename: string): string {
  return `${ROOT_PREFIX}attachments/${id}/${filename}`;
}

export function vaultAttachmentKey(noteId: string, name: string): string {
  return `${ROOT_PREFIX}vault-attachments/${noteId}/${name}`;
}
